import {
  Store, Flame, Trash2, ReceiptText as Receipt, UploadCloud, PackageOpen, ClipboardCheck, FileSpreadsheet,
  BarChart3, Settings, Database, ArrowLeftRight, Package, Link2, Users,
} from "lucide-react";

export const NAV = [
  { key: "rak", label: "Rak Roti", sub: "Home", to: "/", icon: Store },
  {
    key: "transaksi", label: "Transaksi", icon: ArrowLeftRight, children: [
      { key: "dapur", label: "Dapur", sub: "Produksi", to: "/dapur", icon: Flame, perm: "dapur" },
      { key: "waste", label: "Tong Sampah", sub: "Waste Goods", to: "/waste", icon: Trash2, perm: "waste" },
      { key: "kasir", label: "Kasir", sub: "Penjualan", to: "/kasir", icon: Receipt, perm: "kasir" },
      { key: "import", label: "Import Marketplace", sub: "Shopee · Tokopedia", to: "/kasir/import", icon: UploadCloud, perm: "import" },
      { key: "gudang", label: "Gudang Masuk", sub: "Purchase", to: "/gudang", icon: PackageOpen, perm: "gudang" },
      { key: "penyesuaian", label: "Penyesuaian Stok", sub: "Adjustment", to: "/penyesuaian", icon: ClipboardCheck, perm: "penyesuaian" },
    ],
  },
  { key: "kartu", label: "Kartu Stok", sub: "Ledger", to: "/kartu-stok", icon: FileSpreadsheet, perm: "kartu" },
  {
    key: "master", label: "Master", icon: Database, admin: true, children: [
      { key: "produk", label: "Produk", to: "/master/produk", icon: Package },
      { key: "mapping", label: "Mapping Marketplace", to: "/master/mapping", icon: Link2 },
      { key: "user", label: "User", to: "/master/user", icon: Users },
    ],
  },
  { key: "laporan", label: "Laporan", to: "/laporan", icon: BarChart3, perm: "laporan" },
  { key: "pengaturan", label: "Pengaturan", to: "/pengaturan", icon: Settings, admin: true },
];

// Bottom-nav fill order on mobile (Rak Roti is always first; capped at 4 total).
const MOBILE_PRIORITY = ["dapur", "kasir", "waste", "penyesuaian", "gudang", "kartu", "import", "laporan"];

const canSee = (user, item, parentAdmin = false) => {
  if (user?.role === "admin") return true;
  if (item.admin || parentAdmin) return false;
  if (item.perm) return (user?.permissions || []).includes(item.perm);
  return true;
};

export const visibleNav = (user) =>
  NAV
    .map((n) => (n.children ? { ...n, children: n.children.filter((c) => canSee(user, c, n.admin)) } : n))
    .filter((n) => (n.children ? n.children.length > 0 : canSee(user, n)));

export const flatNav = (user) => visibleNav(user).flatMap((n) => (n.children ? n.children : [n]));

export const mobileTabs = (user) => {
  const byKey = Object.fromEntries(flatNav(user).map((n) => [n.key, n]));
  const tabs = byKey.rak ? [byKey.rak] : [];
  for (const k of MOBILE_PRIORITY) {
    if (tabs.length >= 4) break;
    if (byKey[k]) tabs.push(byKey[k]);
  }
  return tabs;
};
